import { generator, compose, getColor, getBorderRadius } from './theme.js';
import { toPx } from './unit.js';

const transform = (value) => {
    if (Number(value) && value !== 0) {
        return `${toPx(value)} solid`;
    }
    if (Number(value) === 0) {
        return 'none';
    }
    return value;
};
const border = (props) => generator({
    props,
    prop: ['border'],
    cssProperty: 'border',
    transform,
});
const borderTop = (props) => generator({
    props,
    prop: ['borderTop'],
    cssProperty: 'borderTop',
    transform,
});
const borderRight = (props) => generator({
    props,
    prop: ['borderRight'],
    cssProperty: 'borderRight',
    transform,
});
const borderBottom = (props) => generator({
    props,
    prop: ['borderBottom'],
    cssProperty: 'borderBottom',
    transform,
});
const borderLeft = (props) => generator({
    props,
    prop: ['borderLeft'],
    cssProperty: 'borderLeft',
    transform,
});
const borderColor = (props) => generator({
    props,
    prop: ['borderColor'],
    cssProperty: 'borderColor',
    getter: getColor,
});
const borderTopColor = (props) => generator({
    props,
    prop: ['borderTopColor'],
    cssProperty: 'borderTopColor',
    getter: getColor,
});
const borderRightColor = (props) => generator({
    props,
    prop: ['borderRightColor'],
    cssProperty: 'borderRightColor',
    getter: getColor,
});
const borderBottomColor = (props) => generator({
    props,
    prop: ['borderBottomColor'],
    cssProperty: 'borderBottomColor',
    getter: getColor,
});
const borderLeftColor = (props) => generator({
    props,
    prop: ['borderLeftColor'],
    cssProperty: 'borderLeftColor',
    getter: getColor,
});
const borderWidth = (props) => generator({
    props,
    prop: ['borderWidth'],
    cssProperty: 'borderWidth',
    transform: toPx,
});
const borderTopWidth = (props) => generator({
    props,
    prop: ['borderTopWidth'],
    cssProperty: 'borderTopWidth',
    transform: toPx,
});
const borderRightWidth = (props) => generator({
    props,
    prop: ['borderRightWidth'],
    cssProperty: 'borderRightWidth',
    transform: toPx,
});
const borderBottomWidth = (props) => generator({
    props,
    prop: ['borderBottomWidth'],
    cssProperty: 'borderBottomWidth',
    transform: toPx,
});
const borderLeftWidth = (props) => generator({
    props,
    prop: ['borderLeftWidth'],
    cssProperty: 'borderLeftWidth',
    transform: toPx,
});
const borderRadius = (props) => generator({
    props,
    prop: ['borderRadius', 'bRadius'],
    cssProperty: 'borderRadius',
    getter: getBorderRadius,
    transform: toPx,
});
const borderTopLeftRadius = (props) => generator({
    props,
    prop: ['borderTopLeftRadius'],
    cssProperty: 'borderTopLeftRadius',
    getter: getBorderRadius,
    transform: toPx,
});
const borderTopRightRadius = (props) => generator({
    props,
    prop: ['borderTopRightRadius'],
    cssProperty: 'borderTopRightRadius',
    getter: getBorderRadius,
    transform: toPx,
});
const borderBottomLeftRadius = (props) => generator({
    props,
    prop: ['borderBottomLeftRadius'],
    cssProperty: 'borderBottomLeftRadius',
    getter: getBorderRadius,
    transform: toPx,
});
const borderBottomRightRadius = (props) => generator({
    props,
    prop: ['borderBottomRightRadius'],
    cssProperty: 'borderBottomRightRadius',
    getter: getBorderRadius,
    transform: toPx,
});
const borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderWidth, borderTopWidth, borderRightWidth, borderBottomWidth, borderLeftWidth, borderRadius, borderTopLeftRadius, borderTopRightRadius, borderBottomLeftRadius, borderBottomRightRadius);

export { border, borderBottom, borderBottomColor, borderBottomLeftRadius, borderBottomRightRadius, borderBottomWidth, borderColor, borderLeft, borderLeftColor, borderLeftWidth, borderRadius, borderRight, borderRightColor, borderRightWidth, borderTop, borderTopColor, borderTopLeftRadius, borderTopRightRadius, borderTopWidth, borderWidth, borders };
